import { authHeader, BASE_URL, handleResponse } from '@helpers/api';
import { ProductEvent } from '@constants/product-events';
import { captureOnSuccess } from '@helpers/product-events';

export const whatsappIntegrationService = {
    authenticateWhatsAppIntegration,
    disconnectIntegration,
};

function authenticateWhatsAppIntegration(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/integrations/whatsapp-official/create-integration`, requestOptions)
        .then(handleResponse)
        .then(captureOnSuccess(ProductEvent.IntegrationConnected, { integration: 'whatsapp' }));
}

function disconnectIntegration(integrationId) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };

    return fetch(
        `${BASE_URL}api/integrations/whatsapp-official/disable-integration?integrationId=${integrationId}`,
        requestOptions,
    ).then(handleResponse);
}
